export default __webpack_public_path__ + "static/media/icon_dice.d11ea7d7.png";